define('viewmodels/modals/dialogs/FaqDialog',['knockout', 'underscore'], function (ko, _) {

    var FaqDialog = function(dialog, questionGroup) {
        var self = this;

        self.dialog = dialog;
        self.title = questionGroup.headline;

        self.questionsAndAnswers = questionGroup.questionsAndAnswers.map(function(original) {
            return _.extend({}, original, {
                expanded: ko.observable(false),
                toggle: function() {
                    var oldState = this.expanded();

                    self.closeAll();
                    this.expanded(!oldState);
                }
            });
        });

        self.closeAll = function() {
            _.each(self.questionsAndAnswers(), function(question) {
                question.expanded(false);
            });
        };
    };

    FaqDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return FaqDialog;
});

